var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import Modal from "../../UI/Modal/Modal";
import useTabs from "../../Hooks/useTabs";
import ModalHeader from "../../UI/Modal/ModalHeader";
const ListGroup = (props) => {
    return _jsx("ul", { className: "list-group", children: props.children });
};
const ListGroupItem = (props) => {
    return _jsx("li", { className: "list-group-item", children: props.children });
};
const LookupIdsFromListModal = (_a) => {
    var { lookupIds } = _a, modalProps = __rest(_a, ["lookupIds"]);
    const [matchedSearch, setMatchedSearch] = useState("");
    const [notMatchedSearch, setNotMatchedSearch] = useState("");
    const [tabs, content] = useTabs({
        tabs: [
            // @ts-expect-error - TS2322 - Type '{ content: (isActive: any) => Element; tab: string; } | null' is not assignable to type 'false'.
            (lookupIds === null || lookupIds === void 0 ? void 0 : lookupIds.matchingRowsCount)
                ? {
                    // eslint-disable-next-line react/display-name
                    content: (isActive) => (_jsxs(_Fragment, { children: [_jsx("div", { className: `input-group mb-2`, children: _jsx("input", { className: "form-control", type: "text", placeholder: "Search by Name or Id", "data-enter-key-press": "search()", value: matchedSearch, onChange: (event) => setMatchedSearch(event.target.value) }) }), _jsx(ListGroup, { children: lookupIds === null || lookupIds === void 0 ? void 0 : lookupIds.matchingAffiliations.filter(
                                // @ts-expect-error - TS7006 - Parameter 'affiliation' implicitly has an 'any' type.
                                (affiliation) => {
                                    var _a;
                                    return (_a = affiliation.text) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(matchedSearch === null || matchedSearch === void 0 ? void 0 : matchedSearch.toLowerCase());
                                }).map((affiliation, index) => (_jsx(ListGroupItem, { children: affiliation.text }, index))) })] })),
                    tab: `Matched (${lookupIds === null || lookupIds === void 0 ? void 0 : lookupIds.matchingRowsCount})`,
                }
                : null,
            // @ts-expect-error - TS2322 - Type '{ content: (isActive: any) => Element; tab: string; } | null' is not assignable to type 'false'.
            (lookupIds === null || lookupIds === void 0 ? void 0 : lookupIds.missingRowsCount)
                ? {
                    // eslint-disable-next-line react/display-name
                    content: (isActive) => (_jsxs(_Fragment, { children: [_jsx("div", { className: `input-group mb-2`, children: _jsx("input", { className: "form-control", type: "text", placeholder: "Search by Id", value: notMatchedSearch, onChange: (event) => setNotMatchedSearch(event.target.value) }) }), _jsx(ListGroup, { children: lookupIds === null || lookupIds === void 0 ? void 0 : lookupIds.missingAffiliations.filter(
                                // @ts-expect-error - TS7006 - Parameter 'affiliation' implicitly has an 'any' type.
                                (affiliation) => {
                                    var _a;
                                    return (_a = affiliation.text) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(notMatchedSearch === null || notMatchedSearch === void 0 ? void 0 : notMatchedSearch.toLowerCase());
                                }).map((affiliation, index) => (_jsx(ListGroupItem, { children: affiliation.text }, index))) })] })),
                    tab: `Not Matched (${lookupIds === null || lookupIds === void 0 ? void 0 : lookupIds.missingRowsCount})`,
                }
                : null,
        ],
        tabStyle: "underline",
        keepAllTabsMounted: false,
    });
    return (_jsx(_Fragment, { children: _jsxs(Modal, Object.assign({}, modalProps, { children: [_jsx(ModalHeader, { title: "Id Lookup", closeModal: modalProps.onModalClosed }), modalProps.isOpen && (_jsx(_Fragment, { children: _jsxs("div", { className: "modal-body", children: [tabs, _jsx("div", { className: "mt-3", children: content })] }) }))] })) }));
};
export default LookupIdsFromListModal;
